import { useEffect } from "react";
import WizardPageWrapper, { GeneralPageSummary } from "../WizardPageWrapper";
import { Checkbox, Form, Space, Typography } from "antd";
import { CoverWizardForm } from "../../CoverWizardModal";
import Flex from "../../../../../../components/Flex";

type AdditionalHardwarePageProps = {
  wizardPageNumberState: [number, React.Dispatch<React.SetStateAction<number>>];
  onBackButtonClick: () => void;
  onNextButtonClick?: () => void;
  getHardware: () => Promise<string[] | undefined>;
  otherHardware: string[] | null;
  extraLongWallAnchors: string[] | null;
  formIsSubmitting?: boolean;
  submitOnNextButtonClick?: boolean;
};

export default function AdditionalHardwarePage({
  wizardPageNumberState: [wizardPhase, setWizardPhase],
  getHardware,
  onBackButtonClick,
  onNextButtonClick,
  otherHardware,
  extraLongWallAnchors,
  formIsSubmitting = false,
  submitOnNextButtonClick = false,
}: AdditionalHardwarePageProps) {
  useEffect(() => {
    getHardware();
  }, []);

  return (
    <WizardPageWrapper
      title="Additional Hardware"
      summary={<GeneralPageSummary />}
      disableScroll
      submitOnNext={submitOnNextButtonClick}
      onNextButtonClick={onNextButtonClick}
      onBackButtonClick={onBackButtonClick}
      nextIsLoading={formIsSubmitting}
    >
      <Typography.Paragraph italic>
        We include the following hardware with every cover: Screw type anchors,
        hex key, 7.5" springs, stow bag, spring covers, tamping tool, steel
        installation rod. Is there anything else we should include?
      </Typography.Paragraph>
      <Typography.Title level={5}>Include the following</Typography.Title>
      <Flex
        vertical
        gap="16px"
        style={{ maxHeight: "400px", overflowY: "auto" }}
      >
        <Form.Item<CoverWizardForm> style={{ margin: "0" }}>
          <Checkbox.Group disabled={formIsSubmitting}>
            <Space direction="vertical">
              <Flex
                vertical
                gap="8px"
                style={{ maxHeight: "calc(97vh - 350px)" }}
              >
                {!otherHardware ? (
                  <Typography.Text>Loading...</Typography.Text>
                ) : (
                  otherHardware.map((hardwareItem) => (
                    <Checkbox
                      disabled={formIsSubmitting}
                      style={{ marginLeft: 0 }}
                      value={hardwareItem}
                      key={hardwareItem}
                    >
                      {hardwareItem}
                    </Checkbox>
                  ))
                )}
                {!!extraLongWallAnchors?.length && (
                  <Flex vertical>
                    <Typography>EXTRA LONG WALL ANCHOR:</Typography>
                    <Flex>
                      {extraLongWallAnchors.map((extraLongWallAnchor) => (
                        <Checkbox
                          disabled={formIsSubmitting}
                          value={extraLongWallAnchor}
                          key={extraLongWallAnchor}
                        >
                          {extraLongWallAnchor.split(" ")?.[0]}
                        </Checkbox>
                      ))}
                    </Flex>
                  </Flex>
                )}
              </Flex>
            </Space>
          </Checkbox.Group>
        </Form.Item>
      </Flex>
    </WizardPageWrapper>
  );
}
